import { gql } from '@apollo/client'
import { MUTATION_STATE } from 'api/fragments'

const PAYLOAD_TYPE = 'CreateVoohCampaignSummaryPdfPayload'

export const CREATE_VOOH_CAMPAIGN_SUMMARY_PDF = gql`
  ${MUTATION_STATE(PAYLOAD_TYPE)}
  mutation createVoohCampaignSummaryPdf($voohCampaignUuid: String!) {
    createVoohCampaignSummaryPdf(input: { voohCampaignUuid: $voohCampaignUuid }) {
      task {
        status
        file
        jobId
        reason
      }
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
